import { z } from "@core/zod";

import { UserScopeSchema } from "./user-scope.ts";

export const OAuthScopeSchema = z.enum(["admin", ...UserScopeSchema.options]);

export const OAuthScopesSchema = z.array(OAuthScopeSchema);
